(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('InvoicesEditFormController', InvoicesEditFormController);

        InvoicesEditFormController.$inject = ['$stateParams', '$state', '$filter', '$sce', 'toastr', '$uibModal', 'FindClientsService', 'InvoicesService', 'SellerService', 'CompaniesService', 'CurrencyService', 'CountriesNewService'];

    function InvoicesEditFormController($stateParams, $state, $filter, $sce, toastr, $uibModal, FindClientsService, InvoicesService, SellerService, CompaniesService, CurrencyService, CountriesNewService) {
        var vm = this;

        vm.base_url                 = base_url;
        vm.invoiceId                = null;
        vm.sellers                  = [];
        vm.companies                = [];
        vm.invoiceType              = '';
        vm.invoiceControlId         = ''; 
        vm.fppCompany               = {};
        vm.user                     = {};
        vm.companySelected          = {};
        vm.subtotal                 = 0;
        vm.total                    = 0;
        vm.discount                 = 0;
        vm.discountPlan             = 0;
        vm.discountWebinar          = 0;
        vm.discountEmailBlast       = 0;
        vm.includeTax               = 0;
        vm.customerVAT              = '';
        vm.customerCountry          = {};
        vm.customerPONumber         = '';
        vm.customerTaxId            = '';
        vm.customerLegalName        = '';
        vm.contactName              = '';
        vm.contactEmail             = '';
        vm.sentTo                   = '';
        vm.vatTax                   = 23;
        vm.totalVat                 = 0;
        vm.showDiscountPlan         = false;
        vm.showDiscountWebinar      = false;
        vm.showDiscountEmailBlast   = false;
        vm.invoiceDate              = {startDate: '', endDate: ''};
        vm.dueDate                  = {startDate: '', endDate: ''};
        vm.notes                    = '';
        vm.invoiceCurrency          = {};
        vm.exchangeRate             = 1;
        vm.nonCommissionable        = 0;
        vm.formErrors               = [];
        vm.focusMe                  = [];
        vm.numberFormat = /^\d*(\.\d+)?$/;

        vm.invoiceSource;
        vm.invoiceSourceData        = {};
        vm.findInvoiceSource        = findInvoiceSource;
        
        // Methods
        vm.loadSellers              = loadSellers; 
        vm.loadCompanies            = loadCompanies; 
        vm.loadCurrencies           = loadCurrencies;
        vm.loadCountries            = loadCountries;
        vm.getCompany               = getCompany;
        vm.fillForm                 = fillForm;
        vm.getInvoiceByControlId    = getInvoiceByControlId;
        vm.setCountry               = setCountry;
        vm.getUserAddress           = getUserAddress;
        vm.updateSubtotal           = updateSubtotal;
        vm.updateTotal              = updateTotal;
        vm.openEditAddressModal     = openEditAddressModal;
        vm.updateInvoice            = updateInvoice;

        vm.optionsDatepicker = { 
            format: "longDate",
            autoUpdateInput: true, 
            singleDatePicker: true, 
            showDropdowns: true
        };

        activate();

        function activate() {

            if ($stateParams.hasOwnProperty('invoice_type')) {
                vm.invoiceType = $stateParams.invoice_type;
            }
            if ($stateParams.hasOwnProperty('control_id')) {
                vm.invoiceControlId = $stateParams.control_id;
            }
            vm.loadSellers();
        }

        function loadSellers() {
            SellerService.getAll().then(function(response) {
                vm.sellers = response.data;
            }).catch(function(err) {
            });
            vm.loadCompanies();
        }

        function loadCompanies() {
            CompaniesService.getAllForSelect().then(function(response) {
                vm.companies = response.data;
                if (vm.companySelected.length == 0) {
                    vm.companySelected = vm.companies[0];
                }
                vm.loadCurrencies();
            }).catch(function(err) {
            });
        }

        function loadCurrencies() {
            CurrencyService.getCurrencies().then(function(response){
                vm.currencies = response.data;
                vm.loadCountries();
            });
        }

        function loadCountries() {
            CountriesNewService.getCountries().then(function(response){
                vm.countries = response.data;
                vm.getInvoiceByControlId($stateParams.control_id);
            });
        }

        function setCountry() {
            vm.customerCountry = $filter('filter')(vm.countries, {id: vm.invoice.exhibitor.country_id})[0];
        }

        function getCompany() {
            vm.query = {};
            vm.query['fpp_company'] = vm.companySelected.id;
            CompaniesService.getByFilter(vm.query).then(function(response) {
                vm.fppCompany.name = response.data.name;
                vm.fppCompany.address = $sce.trustAsHtml(response.data.address);
            }).catch(function(err) {
            });
        }
        
        function getInvoiceByControlId () {
            if($stateParams.hasOwnProperty('control_id')) {
                InvoicesService.getInvoiceByControlID($stateParams.control_id)
                    .then(function(response) {
                        vm.invoice = response.data;
                        vm.currency = vm.invoice.currency;
                        vm.fillForm(vm.invoice);
                    })
            } else {
                // Redirect user to another page
            }
        }

        function fillForm (invoice) {
            
            // Set Company
            let companySelected = vm.companies.filter(item => item.id == invoice.fpp_company);
            if(companySelected.length) {
                vm.companySelected = companySelected[0];
            }
            vm.getCompany();
            vm.getUserAddress();
            
            // Set Country
            let countrySelected = vm.countries.filter(item => item.id == invoice.customer_country_id)
            if(countrySelected.length) {
                vm.customerCountry = countrySelected[0];
            }

            // Set Customer PO Number
            vm.customerPONumber = invoice.customer_po_number;

            // Set Customer TaxId
            vm.customerTaxId = invoice.customer_tax_id;

            // Set Customer Legal Name
            vm.customerLegalName = invoice.customer_legal_name;

            // Set Contact Name
            vm.contactName = invoice.contact_name;

            // Set Contact Email
            vm.contactEmail = invoice.contact_email;

            // Set Sent To
            vm.sentTo = invoice.sent_to;

            // Set Seller
            let sellerSellected = vm.sellers.filter(item => item.id == invoice.seller_id)
            if(sellerSellected.length) {
                vm.sellerSelected = sellerSellected[0];
            }

            // Set Invoice Date
            vm.invoiceDate = invoice.invoice_date;

            // Set Invoice Due Date
            vm.dueDate = invoice.due_date;

            // Set Invoice Currency
            let invoiceCurrency = vm.currencies.filter(item => item.code == invoice.currency)
            if(invoiceCurrency.length) {
                vm.invoiceCurrency = invoiceCurrency[0];
            }

            // Set Non Commissionable
            vm.nonCommissionable = invoice.non_commissionable == 1 ? true : false;

            // Set Notes
            vm.notes = invoice.observation;

            // Set Discounts
            vm.discount = invoice.discount_rate;
            vm.discountPlan = invoice.discount_plan_rate;
            vm.discountWebinar = invoice.discount_webinars_rate;
            vm.discountEmailBlast = invoice.discount_email_blasts_rate;

            vm.invoiceSource = invoice.invoice_source;
            vm.findInvoiceSource();

            // Update Subtotal
            vm.updateSubtotal();
        }

        function getUserAddress() {
            FindClientsService.getAddresses(vm.invoice.exhibitor.user_id).then(function(response) {
                vm.addresses = response.data;
                if (vm.addresses.length > 0) {
                    vm.addressSelected = vm.addresses[0];
                    vm.user.address = vm.addresses[0].address + '<br>' +
                        vm.addresses[0].city_name + ', ' +
                        vm.addresses[0].region_name + ' ' +
                        vm.addresses[0].zip_code + '<br>' +
                        vm.addresses[0].country_name; 
                    vm.invoice.exhibitor.addressHTML = $sce.trustAsHtml(vm.user.address);
                    if (vm.addresses[0].country_id) {
                        vm.setCountry();
                    }
                }

            }).catch(function(err) {
            });
        }

        function updateSubtotal() {
            var subtotal = 0;
            if (vm.invoice['expos']) {
                angular.forEach(vm.invoice['expos'], function (expo) {
                    angular.forEach(expo['items'], function (item) {
                        subtotal = parseFloat(subtotal) + parseFloat(item.rate);
                    });
                });
            }

            if (vm.invoice['virtual_fairs']) {
                angular.forEach(vm.invoice['virtual_fairs'], function (virtual_fair) {
                    angular.forEach(virtual_fair['items'], function (item) {
                        subtotal = parseFloat(subtotal) + parseFloat(item.rate);
                    });
                });                
            }

            if (vm.invoice['general']) {
                angular.forEach(vm.invoice['general']['items'], function (item) {
                    subtotal = parseFloat(subtotal) + parseFloat(item.rate);
                });
            }

            if (vm.invoice['additional_services']) {
                angular.forEach(vm.invoice['additional_services']['items'], function (as) {
                    subtotal = parseFloat(subtotal) + parseFloat(as.rate);
                });
            }
            vm.subtotal = subtotal;
            vm.updateTotal();
        }

        function updateTotal() {
            vm.total =
                parseFloat(vm.subtotal) -
                parseFloat(vm.discount) -
                parseFloat(vm.discountPlan) -
                parseFloat(vm.discountWebinar) -
                parseFloat(vm.discountEmailBlast);

            if (vm.includeTax == 1){
                vm.totalVat = parseFloat((parseFloat(vm.total) * parseFloat(vm.vatTax))/100).toFixed(2);
                vm.total = parseFloat(vm.total) + parseFloat(vm.totalVat);
            }
        }

        function openEditAddressModal() {

            $uibModal.open({
                templateUrl: 'templates/invoices/form/editAddress/editAddress.html',
                controller: 'EditAddressController',
                controllerAs:'editAddress',
                resolve:
                {
                    user : function () {
                        return vm.invoice;
                    },
                }
            });
        }

        function updateInvoice()
        {
            let query = {};
            query['customer_country_id'] = vm.customerCountry.id;
            query['customer_po_number'] = vm.customerPONumber;
            query['customer_tax_id'] = vm.customerTaxId;
            query['customer_legal_name'] = vm.customerLegalName;
            query['contact_name'] = vm.contactName;
            query['contact_email'] = vm.contactEmail;
            query['sent_to'] = vm.sentTo;
            query['due_date'] = moment(vm.dueDate).format('YYYY-MM-DD');
            query['observation'] = vm.notes;

            if(vm.invoiceSource) {
                query['invoice_source'] = vm.invoiceSource;
            }

            InvoicesService.updateInvoice(vm.invoiceControlId, query).then(function(){
                
                var params = { 
                    id: vm.invoice.customer_id, 
                    invoice_updated: vm.invoice.id, 
                    control_id: vm.invoice.control_id 
                }; 

                if (vm.invoice.expos) {
                    $state.go("root.invoices.user", params);
                } else if (vm.invoice.virtual_fairs) {
                    params.virtual_fair_id = 'active';
                    $state.go("root.invoices.virtual_fair.user", params);
                } else {
                    $state.go("root.invoices.search", params);
                }

            }).catch(function(err) {
                toastr.error(err);
            });
        }

        function findInvoiceSource() {
            vm.query = {};           
            vm.query['page'] = 1;            
            vm.query['control_id'] = vm.invoiceSource; 

            vm.invoiceSourceData = {};       
            vm.formErrors = [];        
            vm.focusMe = [];
            vm.validForm = true;

            InvoicesService.getInvoicesByFilter(vm.query).then(function(response) {

                vm.invoiceSourceData = response.data.data[0];   
                if (!vm.invoiceSourceData) {
                    vm.invoiceSourceData = false; 
                    vm.invoiceSource = '';
                    vm.formErrors['invoice_source'] = ['Invoice not found: ' + vm.query['control_id']];   
                    vm.validForm = false;                 
                }                

            }).catch(function(err) {
            });
        } 

    }

})();
